<template>
  <div class="card">
    <div class="field-item van-hairline--bottom">
      <div class="field-item-title bold">排行榜</div>
      <!-- <van-switch
        v-model="form.boolRankList"
        size="24px"
        active-color="#FF6B31"
        inactive-color="#f4f4f4"
      /> -->
      <van-radio-group v-model="form.boolRankList" direction="horizontal" icon-size="16px" checked-color="#FF6B31">
        <van-radio :name="false">关闭</van-radio>
        <van-radio :name="true">开启</van-radio>
      </van-radio-group>
    </div>
    <template v-if="form.boolRankList">
      <van-form 
        :show-error-message="false" 
        validate-trigger="onSubmit" 
        validate-first
        ref="form"
      >
        <van-field
          class="fee-value text-input"
          readonly
          v-model="form.showTypeStr"
          @click="isShowtype = true"
          label="展示类型"
          label-width="13.5em"
          placeholder="请选择"
          :rules="[{ required: true, message: '请选择展示类型' }]"
          is-link
        ></van-field>
        <van-field name="switch" label-width="9em" input-align="right" label="是否开启虚拟数据">
          <template #input>
            <!-- <van-switch v-model="form.boolVirtualData" size="24px" active-color="#FF6B31" inactive-color="#f4f4f4"/> -->
            <van-radio-group v-model="form.boolVirtualData" direction="horizontal" icon-size="16px" checked-color="#FF6B31">
              <van-radio :name="false">关闭</van-radio>
              <van-radio :name="true">开启</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <div class="tips tips-bg van-hairline--bottom">开启虚拟数据后，将会在排行榜中进行展示</div>
        <template v-if="form.boolVirtualData">
          <van-field
            class="fee-value text-input"
            v-model="form.virtualPeople"
            label="虚拟"
            label-width="8em"
            placeholder="请输入虚拟人数"
            :disabled="sourceType == 2 && virtualData.first == 1"
            type="digit"
            :rules="[{ required: true, message: '请输入虚拟人数' }]"
            @blur="onMaxFissionNumChange('virtualPeople')"
          >
            <span slot="right-icon">人</span>
          </van-field>
          <van-field
            class="fee-value text-input"
            v-model="form.virtualMoney"
            label="虚拟最大金额为"
            :disabled="sourceType == 2 && virtualData.first == 1"
            label-width="13.5em"
            placeholder="请输入"
            type="number"
            :rules="[{ required: true, message: '请输入虚拟最大金额为' }]"
            @blur="onMaxFissionNumChange('virtualMoney')"
          >
            <span slot="right-icon">元</span>
          </van-field>
          <div class="data-box1">
            <template v-if="virtualData.redVirtualDataList && ( form.showType == 1 || form.showType == 2)">
              <div class="title">现金红包</div>
              <div class="list-item"  v-for="(item,index) in virtualData.redVirtualDataList" :key="index">
                <img :src="item.avatar" />
                <div class="name">{{item.name}}</div>
                <div class="money">{{item.amount}}元</div>
              </div>
            </template>
            <template v-if="virtualData.fissionVirtualDataList && (form.showType == 1 || form.showType == 3)">
              <div class="title">裂变佣金</div>
              <div class="list-item"  v-for="(item,index) in virtualData.fissionVirtualDataList" :key="index+1*100">
                <img :src="item.avatar" />
                <div class="name">{{item.name}}</div>
                <div class="money">{{item.amount}}元</div>
              </div>

            </template>
          </div>
          <div class="btuon-box" v-if="sourceType != 2 || virtualData.first != 1">
            <van-button round block color="#ff6b31" size="small" @click="generateData">生成虚拟数据</van-button>
          </div>
        </template>
      </van-form>
    </template>
    <van-popup v-model="isShowtype" round position="bottom" get-container="body"  >
      <van-picker
        title="标题"
        show-toolbar
        :columns="showType"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>
  </div>
</template>

<script>
import { round2Places } from "@/utils/utils";
export default {
	model: {
    prop: 'value',
    event: 'change'
  },
	props: {
		value: {
			type: Object,
			default() {
				return {}
			}
		},
    rankData: {
      type: Object,
      default() {
        return {}
      }
    },
    // 1:创建  2:附加
    sourceType: Number,
    
	},
	computed: {
		form: {
			get() {
				return this.value
			},
			set(val) {
				this.$emit('change', val)
			}
		},
    virtualData: {
      get() {
        return this.rankData
      },
      set(newVal){
        this.$emit('update:rankData',newVal)
      }
    },
	},
  watch: {
    'value.virtualPeople':{
      handler(newV,oldV) {
        if (oldV && (newV != oldV)) {
          this.virtualData = {}
          this.form.keyId = ''
        }
      }
    },
    'value.virtualMoney':{
      handler(newV,oldV) {
        if (oldV && (newV != oldV)) {
          this.virtualData = {}
          this.form.keyId = ''
        }
      }
    }
  },
  data() {
    return {
      isShowtype: false,
      showType: [{text: '全部', type: 1},{text: '现金红包', type: 2},{text: '裂变佣金', type: 3}],
      showTypeStr: '',
    };
  },
  methods: {
    onConfirm(e) {
      const { text, type } = e
      this.form.showTypeStr = text
      this.form.showType = type
      this.isShowtype = false
    },
    onCancel() {
      this.isShowtype = false
    },
		 onMaxFissionNumChange(fieldName) {
      const model = this.form;
      const fieldValue = model[fieldName];
      model[fieldName] = round2Places(fieldValue)
    },
    generateData() {
      this.$refs.form.validate().then( res => {
        this.$dialog.alert({
          title: '提示',
          message: '虚拟数据一经保存，将无法再次修改<br/>数据可重复生成',
        }).then(res => {
          this.getVirtual()
        })
      }).catch(err => {
        this.$toast(err[0].message);
        
      })
    },
    getVirtual() {
      const {virtualPeople,virtualMoney} = this.form
        this.$api.activityMgmt.createVirtualData({
          showType: 1,
          maxAmount: virtualMoney,
          num: virtualPeople,
        }).then(res => {
          if (res.success) {
            this.virtualData = res.data
            this.form.keyId = res.data.keyId
          }
        })
    },
    // 必填项校验
    onFailed() {
      return new Promise((resolve,reject) => {
        if (this.form.boolRankList) {
          this.$refs.form.validate().then( res => {
            if (this.form.boolVirtualData) {
              if (this.form.keyId == '') {
                this.$toast('请生成虚拟数据');
                reject(false)
                return
              }
            }
              resolve(true)
            }).catch(err => {
              this.$toast(err[0].message);
              reject(false)
            })
        }else {
          resolve(true)
        }
      })
    }
  },
};
</script>

<style lang="stylus" scoped>
.card
  margin 15px
  overflow: hidden
  border-radius: 8px
  background: #fff;

.field-item
  display: flex
  justify-content: space-between
  align-items: center
  padding 10px 16px
  font-size 14px
  background-color: #fff
  &-title
    color #323233
		font-weight 600

.fee-value
  >>> .van-cell__value input
    text-align: right

.range-card
  margin 15px 0
  padding 10px 16px
  background-color: #fff
  border-radius: 8px
  &-head
    padding-bottom 10px
    display: flex
    justify-content: space-between
    font-size 14px
    font-weight 600

.range-field
  display: flex
  justify-content: space-between
  align-items: center
  padding 10px 0
  font-size 14px
  &-label
    color #606266
    flex none
  &-content
    display: flex
    align-items: center
    justify-content: space-around

    >span
      margin 0 10px

    .range-input
      padding 0
      line-height 1
      &::after
        border-bottom: none
      >>> .van-field__body
        width 105px
        input
          border-bottom: 1px solid #ebedf0
          text-align: center
.tips
  padding 0 16px 5px
  font-size 12px
  color #bbb
  text-align: right
.tips-bg
  background-color: #fff
.data-box1 {
  padding: 10px 16px;
  .title {
    padding: 10px 0;
    font-weight: bold;
  }
  .list-item {
    display: flex;
    justify-content: space-between
    align-items: center
    padding: 8px 0;
    img {
      width: 35px;
      height: 35px;
      margin-right: 10px;
      border-radius: 50%;
    }
    .name {
      width: 50%
    }
    .money {
      width: 40%;
      text-align: right;
    }
  }
}
.btuon-box {
  padding: 10px 60px;
}
</style>
